import React, { useMemo } from 'react';
import { FilterContent, SearchWrapper } from './filter-feedback-request.styles';
import { Checkbox } from '@vtbhome/juicyfront';
import { FilterFeedbackRequestsProps } from './types';
import { DEFAULT_FEEDBACK_REQUESTS_LIST_PARAMETERS } from '@entities/feedback-request/config/store-constants';
import { Select } from '@shared/ui/select/select';
import { FEEDBACK_REQUEST_TEXT_STATUS_MAP } from '@entities/feedback-request/config/ui-constants';
import { getSelectOptionFromObject } from '@shared/lib/utils/normalize-select-options/normalize-select-options';
import { FeedbackRequestStatus } from '@shared/model/feedback-request';
import dayjs from 'dayjs';
import { IDateVariants } from '@vtbhome/juicyfront/types/projects.types';
import { Datepicker } from '@shared/ui/datepicker/datepicker';
import { normalizeDatepickerValue } from '@shared/lib/utils/normalize-datepicker-value/normalize-datepicker-value';
import { Search } from '@shared/ui/search/search';
import { Filter } from '@shared/ui/filter/filter';
import { SORT_FEEDBACK_REQUESTS_CLEAR_PARAMETERS } from './constants';

export const FilterFeedbackRequests: React.FC<FilterFeedbackRequestsProps> = ({
    children,
    feedbackRequestsListParameters,
    setFeedbackRequestsListParameters,
}) => {
    const feedbackRequestsStatusSelectValues = useMemo(() => {
        if (feedbackRequestsListParameters.status) {
            return [
                {
                    label: FEEDBACK_REQUEST_TEXT_STATUS_MAP[feedbackRequestsListParameters.status],
                    value: feedbackRequestsListParameters.status,
                },
            ];
        }
        return [];
    }, [feedbackRequestsListParameters.status]);

    const onChangeDatepicker = (date: IDateVariants) => {
        const [startAt, endAt] = date.value?.match(/((\d+\.?)+)/g) || ['', ''];

        setFeedbackRequestsListParameters((prev) => ({
            ...prev,
            dateFrom: startAt ? dayjs.utc(startAt, 'DD.MM.YYYY').startOf('D').format() : null,
            dateTo: endAt ? dayjs.utc(endAt, 'DD.MM.YYYY').endOf('D').format() : null,
        }));
    };

    return (
        <SearchWrapper>
            <Search
                sortParametersAfterClearSearch={SORT_FEEDBACK_REQUESTS_CLEAR_PARAMETERS}
                parameters={feedbackRequestsListParameters}
                placeholder='Поиск'
                setParameters={setFeedbackRequestsListParameters}
            />
            {children}
            <Filter
                onResetAllFilters={() => setFeedbackRequestsListParameters(DEFAULT_FEEDBACK_REQUESTS_LIST_PARAMETERS)}>
                <FilterContent>
                    <Select
                        label='Статус'
                        placeholder='Выберите из списка'
                        values={feedbackRequestsStatusSelectValues}
                        options={getSelectOptionFromObject(FEEDBACK_REQUEST_TEXT_STATUS_MAP)}
                        onChange={(value) =>
                            setFeedbackRequestsListParameters((prev) => ({
                                ...prev,
                                status: value[0]?.value as FeedbackRequestStatus,
                            }))
                        }
                    />
                    <Datepicker
                        range
                        label='Период обращения'
                        defaultValue={normalizeDatepickerValue(
                            feedbackRequestsListParameters.dateFrom,
                            feedbackRequestsListParameters.dateTo
                        )}
                        onChange={onChangeDatepicker}
                    />
                    <Checkbox
                        label='Отображать только мои темы'
                        checked={feedbackRequestsListParameters.my}
                        onChange={(e) =>
                            setFeedbackRequestsListParameters((prev) => ({
                                ...prev,
                                my: e.target.checked,
                            }))
                        }
                    />
                </FilterContent>
            </Filter>
        </SearchWrapper>
    );
};
